import {parse} from 'qs'
import {__, assoc, pipe} from 'ramda'

import {
  filterABTestParameters,
  removeForcePrefix
} from '../../../experiments/utils'
import {RawParamsType} from '../../../utils/url/types/UrlParams'
import {isBrowser} from '../environment'

const curriedParse = (url: string) =>
  parse(url, {
    ignoreQueryPrefix: true
  }) as RawParamsType

/**
 * Gets query params of passed url
 * @param url - url with params
 * @returns object with a list of param: value taken from given url
 * composed with enabled experiments and useAgentData
 */
export const urlParamsParser = (url: string) => {
  const parseAllowedParams = pipe(curriedParse)

  const parseForcedExperiments = pipe(
    curriedParse,
    filterABTestParameters,
    removeForcePrefix,
    assoc('experiments', __, {})
  )

  return {
    ...parseAllowedParams(url),
    ...parseForcedExperiments(url)
  }
}

/**
 * Wrapper around history.location.search
 * @returns List of params from history.location.search
 * composed with enabled experiments and useAgentData
 */
const parser = () => {
  if (!isBrowser) return {}
  return urlParamsParser(location.search)
}

export default parser
